import api from '../utils/api'

const warrantyService={
  list:async params=>(await api.get('/api/warranties',{params})).data.data||[],
  get:async id=>(await api.get(`/api/warranties/${id}`)).data.data,
  claims:async params=>(await api.get('/api/warranties/claims/list',{params})).data.data||[],
  createClaim:async data=>(await api.post('/api/warranties/claims',data)).data,
  updateClaim:async(id,data)=>(await api.patch(`/api/warranties/claims/${id}/status`,data)).data
}
export default warrantyService
